import { render, staticRenderFns } from "./read.vue?vue&type=template&id=ec8610b0&scoped=true"
import script from "./read.vue?vue&type=script&lang=js"
export * from "./read.vue?vue&type=script&lang=js"
import style0 from "./read.vue?vue&type=style&index=0&id=ec8610b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8610b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec8610b0')) {
      api.createRecord('ec8610b0', component.options)
    } else {
      api.reload('ec8610b0', component.options)
    }
    module.hot.accept("./read.vue?vue&type=template&id=ec8610b0&scoped=true", function () {
      api.rerender('ec8610b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/news/read.vue"
export default component.exports